import { fetchGet, fetchPut, fetchDelete } from '../../../../../../helpers/fetching';
import { getInterfaceTypeConfig } from '../Interfaces.config';

const getConfig = (typeId) => {
  const config = getInterfaceTypeConfig(typeId);
  if (!config?.endpoint) return null;
  return config;
};

// Load nodes for a specific interface type.
export const loadNodes = async (typeId) => {
  const config = getConfig(typeId);
  if (!config) {
    return { success: false, msg: 'Invalid interface configuration' };
  }

  try {
    const response = await fetchGet(config.endpoint);
    if (response.success && response.data) {
      const normalized = (response.data || []).map((item) => ({
        ...config.normalize(item),
        _typeId: typeId,
      }));
      return { ...response, data: normalized };
    }
    return response;
  } catch (error) {
    return { success: false, msg: error.message || 'Failed to load nodes' };
  }
};

// Save or update a node.
export const saveNode = async (typeId, payload) => {
  const config = getConfig(typeId);
  if (!config) {
    return { success: false, msg: 'Invalid interface configuration' };
  }

  try {
    return await fetchPut(config.endpoint, payload);
  } catch (error) {
    return { success: false, msg: error.message || 'Failed to save node' };
  }
};

// Delete a node.
export const deleteNode = async (typeId, name) => {
  const config = getConfig(typeId);
  if (!config) {
    return { success: false, msg: 'Invalid interface configuration' };
  }

  try {
    return await fetchDelete(config.endpoint, { name });
  } catch (error) {
    return { success: false, msg: error.message || 'Failed to delete node' };
  }
};

// Test a node connection.
export const testNode = async (typeId, nodeName) => {
  const config = getConfig(typeId);
  if (!config || !config.hasTest) {
    return { success: false, msg: 'Test not supported for this node type' };
  }

  try {
    const endpoint = config.testEndpoint(nodeName);
    return await fetchGet(endpoint, 'bbox');
  } catch (error) {
    return { success: false, msg: error.message || 'Test failed' };
  }
};

// Ping test a server.
export const pingTestNode = async (typeId, nodeName) => {
  const config = getConfig(typeId);
  if (!config || !config.hasPingTest || !config.pingEndpoint) {
    return { success: false, msg: 'Ping test not supported for this node type' };
  }

  try {
    return await fetchGet(config.pingEndpoint(nodeName), 'bbox');
  } catch (error) {
    return { success: false, msg: error.message || 'Ping test failed' };
  }
};
